"use client";

import type { ReactNode, FC } from "react";
import { Card, type ClassNameProp, Flex, Text } from "@huub-web/ui";
import { useTranslation } from "react-i18next";
import { mergeClasses } from "@huub-web/utils";

import {
  contentClassName,
  innerStyle,
  tagLineStyle,
  timesStyle,
} from "./ChanceCard.css";

export type ChanceCardProps = ClassNameProp & {
  innerClassName: string;
  hasPartner?: boolean;
  cta?: ReactNode;
};

export const ChanceCard: FC<ChanceCardProps> = ({
  className,
  innerClassName,
  hasPartner = false,
  cta,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      variant="gradientAlternative"
      className={mergeClasses(className)}
      innerClassName={mergeClasses(innerStyle, innerClassName)}
      contentClassName={contentClassName}
      padding="s"
    >
      <Flex as="h4" gap="xxs" align="center">
        <Text as="span" className={timesStyle}>
          4&times;
        </Text>
        <Text as="span" variant="bodyM" className={tagLineStyle}>
          {t(
            `maxMortgageWizard.result.chanceCard.tagline.${hasPartner ? "plural" : "singular"}`,
          )}
        </Text>
      </Flex>
      {cta}
    </Card>
  );
};
